import { AppointmentModel } from '../../models/appointment';

import { Appointment } from './types';

const isCancelledStatus = (status: string | null | undefined): boolean => {
  return status?.toLowerCase().includes('cancel') ?? false;
};

export const convertTebraDataToAppointmentModel = (
  data: Appointment,
): AppointmentModel => {
  const patientSummary = data.patientSummaries?.[0];

  const appointmentModel: AppointmentModel = {
    externalId: data.appointmentGuid ?? '',
    externalPatientId:
      patientSummary?.guid ??
      (patientSummary?.patientId != null ? `${patientSummary.patientId}` : ''),
    externalPractitionerId: undefined,
    firstName: patientSummary?.firstName ?? '',
    lastName: patientSummary?.lastName ?? '',
    startTime: data.startTime ? new Date(data.startTime).toISOString() : '',
    endTime: data.endTime ? new Date(data.endTime).toISOString() : '',
    name: data.appointmentName ?? '',
    description: data.notes ?? '',
    rawEhrData: data,
    status: isCancelledStatus(data.appointmentStatus) ? 'CANCELLED' : undefined,
    isArchived: isCancelledStatus(data.appointmentStatus),
    isImportable: !isCancelledStatus(data.appointmentStatus),
    sessionType: undefined,
  };

  return appointmentModel;
};
